import { render, staticRenderFns } from "./placard.vue?vue&type=template&id=37a8c4c2&"
import script from "./placard.vue?vue&type=script&lang=js&"
export * from "./placard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports